// @flow

import type { RouterHistory } from 'react-router-dom';

import { basePath } from '../../constants/commonConstants';
import { CAR_INSURANCE_TYPE } from '../../constants/insuranceTypeConstants';
import { PAYLOADVALUE } from '../../constants/retriveUserConstant';
import {
  AGENT_SELECTED_QUOTE,
  USER_QUOTE_LIST
} from '../../constants/sessionStorage/userStorageIdentifiers';
import {
  getObjectFromSessionStorage,
  makeRequest,
  removeFromSessionStorage,
  saveObjectInSessionStorage
} from '../../helpers';
import type { GetPolicyDocumentResponse } from '../../types/commonTypes';

export const getGenericDocumentLinks = async (
  insuranceType: string,
  policyReference: string,
  history: RouterHistory
): Promise<GetPolicyDocumentResponse> => {
  const url =
    insuranceType === CAR_INSURANCE_TYPE
      ? '/motor/motor_quotes/documents'
      : '/travel/travel_quotes/documents';
  return makeRequest({
    url: `${basePath}${url}?policyReference=${policyReference}`,
    method: 'GET',
    history
  });
};

export const updateUserAttribute = async (
  // eslint-disable-next-line flowtype/no-weak-types
  phoneNumber: any,
  // eslint-disable-next-line flowtype/no-weak-types
  userName: any,
  // eslint-disable-next-line flowtype/no-weak-types
  props: any = {}
) => {
  return await makeRequest({
    method: 'PUT',
    url: `${basePath}/update_phone_number`,
    history: props.history,
    payload: {
      user_name: userName,
      phone_number: phoneNumber
    }
  });
};

export const getDocument = async (
  // eslint-disable-next-line flowtype/no-weak-types
  payload: any,
  url: string,
  // eslint-disable-next-line flowtype/no-weak-types
  props: Object = {}
) => {
  return makeRequest({
    method: 'POST',
    url: `${basePath}${url}`,
    payload: {
      document_id: payload
    },
    history: props.history
  });
};

export const getFeatureFlags = async () => {
  return makeRequest({
    method: 'GET',
    url: `${basePath}/feature`
  });
};

// eslint-disable-next-line flowtype/no-weak-types
export const isVerifiedUser = async (email: any) => {
  try {
    return await makeRequest({
      method: 'POST',
      url: `${basePath}/verified`,
      payload: {
        email: email
      }
    });
  } catch {
    return {
      mfa_enable: false,
      number_verified: false
    };
  }
};

// eslint-disable-next-line flowtype/no-weak-types
export const collateUserSearchResults = async (values: any, userList: any) => {
  if (userList.pagination_token && userList.pagination_token.length > 0) {
    let continuedRequest = await makeRequest({
      method: 'POST',
      url: `${basePath}/home/applied_home_quotes/user_latest_quotes`,
      payload: {
        [PAYLOADVALUE[`${values.dropdownValue}`]]: values.searchInput,
        starts_with: true,
        limit: 10,
        pagination_token: userList.pagination_token
      }
    });
    // eslint-disable-next-line require-atomic-updates
    userList.user_quote_map = {
      ...userList.user_quote_map,
      ...continuedRequest.user_quote_map
    };
    // eslint-disable-next-line require-atomic-updates
    userList.pagination_token = continuedRequest.pagination_token;
    await collateUserSearchResults(values, userList);
  } else {
    if (getObjectFromSessionStorage(USER_QUOTE_LIST)) {
      removeFromSessionStorage(USER_QUOTE_LIST);
    }
    saveObjectInSessionStorage(USER_QUOTE_LIST, userList);
  }
};

// eslint-disable-next-line flowtype/no-weak-types
export const getLatestQuoteUsers = async (values: any) => {
  try {
    return await makeRequest({
      method: 'POST',
      url: `${basePath}/home/applied_home_quotes/latest_quotes_users`,
      payload: values.searchInput
    });
  } catch {
    return [];
  }
};

// eslint-disable-next-line flowtype/no-weak-types
export const getLatestQuoteForPolicyCode = async (policyCode: any) => {
  try {
    const response = await makeRequest({
      method: 'GET',
      url: `${basePath}/home/applied_home_quotes/latest/policy_code?policyCode=${policyCode}`
    });
    saveObjectInSessionStorage(AGENT_SELECTED_QUOTE, response);
  } catch {
    return [];
  }
};

// eslint-disable-next-line flowtype/no-weak-types
export const getLatestQuotesForEmail = (email: any) => {
  return makeRequest({
    method: 'POST',
    url: `${basePath}/home/applied_home_quotes/latest_quotes`,
    payload: {
      email: email
    }
  });
};

export const getLatestHomeQuotesByType = async (
  // eslint-disable-next-line flowtype/no-weak-types
  request: any,
  // eslint-disable-next-line flowtype/no-weak-types
  page_number: any,
  // eslint-disable-next-line flowtype/no-weak-types
  page_size: any,
   // eslint-disable-next-line flowtype/no-weak-types
  type: any
): Promise<any> => {
  try {
    return await makeRequest({
      method: 'POST',
      url: `${basePath}/home/applied_home_quotes/latest_quotes_search`,
      payload: {
        search_criteria: request,
        search_type: type,
        page_number: page_number,
        page_size: page_size
      }
    });
  } catch {
    return [];
  }
};

// eslint-disable-next-line flowtype/no-types-missing-file-annotation
export const validatePromoAlias = async (alias: string) => {
  const validatePromoResponse = await makeRequest({
    method: 'GET',
    url: `${basePath}/home/promo/validate?promoCode=${alias}`
  });
  return validatePromoResponse === true ? validatePromoResponse : false;
};
